module.exports = __webpack_public_path__ + "img/4.c2820e90.jpg";